import React from 'react';
import { Container, Image, Text, Button, Stack, Center, Paper } from '@mantine/core';
import { IconArrowRight } from '@tabler/icons-react';
import { Link, useNavigate } from 'react-router-dom';

import thankYouLogo from '../assets/thank-you.png';
import { useEffect } from 'react';

export default function ThankYouPage() {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/dashboard');
    }, 35_000);

    return () => clearTimeout(timer);
  }, [navigate]);


  return (
    <Container size="sm" py="xl">
      <Center style={{ height: '80vh' }}>
        <Paper radius="md" shadow="lg" p="xl" withBorder>
          <Stack align="center" gap="md">
            <Image
              src={thankYouLogo}
              alt="Thank you"
              width={250}
              mb="md"
            />
            <Text size="xl" fw={600} ta="center">
              Thank you, and welcome to LSAT Gains!
            </Text>
            <Text c="dimmed" ta="center">
              Your test packet is currently being currated. Please wait a few moments or click the button below to continue.
            </Text>
            <Button
              component={Link}
              to="/dashboard"
              rightSection={<IconArrowRight size={18} />}
              radius="xl"
              variant="gradient"
              gradient={{ from: 'indigo', to: 'cyan' }}
              size="md"
              mt="md"
            >
              Go to Dashboard
            </Button>
          </Stack>
        </Paper>
      </Center>
    </Container>
  );
}
